/**
 * Settings > Guardrails tab hooks — see src/queries/webhooks.js for the
 * template this follows.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import { request, ReqMethods } from "../lib/apiClient";

const { GET, POST } = ReqMethods;

export const guardrailsKeys = {
  byProfile: (profileId) => ["guardrails", profileId],
};

export function useGuardrails(profileId) {
  return useQuery({
    queryKey: guardrailsKeys.byProfile(profileId),
    queryFn: async () => {
      const res = await request(GET, `/users/guardrails/${profileId}`);
      return res?.data ?? null;
    },
    enabled: !!profileId,
  });
}

// Fired imperatively from the PII Switch's onCheckedChange — the caller owns
// the optimistic toggle + rollback-on-error around this call.
export function useUpdateGuardrails(profileId) {
  return useMutation({
    /** @param {{piiEnabled: boolean}} payload */
    mutationFn: (payload) => request(POST, `/users/guardrails/${profileId}`, { payload }),
  });
}
